import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40637bb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_edit_quick_routing",
  ref: "editQuickRoutingRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_edit_quick_routing_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1))
const _hoisted_8 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary max-sm-align-items-start"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_11 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_edit_quick_routing_scroll",
  "data-kt-scroll": "false",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_edit_quick_routing_header",
  "data-kt-scroll-wrappers": "#kt_modal_edit_quick_routing_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  key: 0,
  class: "col-md-12 mb-7"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "fs-6 text-gray-400" }
const _hoisted_16 = { class: "el-form-item__content" }
const _hoisted_17 = {
  key: 1,
  class: "col-md-12 mb-7"
}
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "fs-6 text-gray-400" }
const _hoisted_20 = { class: "el-form-item__content" }
const _hoisted_21 = {
  key: 2,
  class: "col-md-12 mb-7"
}
const _hoisted_22 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6" }
const _hoisted_23 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_24 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_25 = { class: "text-gray-900 fw-bold" }
const _hoisted_26 = { class: "fw-semibold" }
const _hoisted_27 = { class: "fs-6 text-gray-700" }
const _hoisted_28 = {
  key: 3,
  class: "col-md-12 mb-7"
}
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "fs-6 text-gray-400" }
const _hoisted_31 = { class: "el-form-item__content" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "form-group mb-7" }
const _hoisted_34 = { class: "d-flex align-items-center justify-content-between fs-6 fw-bold mb-4" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_37 = { class: "svg-icon svg-icon-4 svg-icon-primary me-2" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "w-100 d-flex flex-column gap-4 lh-sm" }
const _hoisted_40 = { class: "w-100 cursor-pointer" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "symbol symbol-50px overflow-hidden" }
const _hoisted_43 = { class: "symbol-label" }
const _hoisted_44 = { class: "svg-icon svg-icon-1" }
const _hoisted_45 = { class: "flex-fill mx-2" }
const _hoisted_46 = { class: "fw-bold fs-5" }
const _hoisted_47 = { class: "d-flex align-items-center" }
const _hoisted_48 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 0,
  class: "w-100 cursor-pointer"
}
const _hoisted_51 = { class: "d-flex align-items-center" }
const _hoisted_52 = { class: "symbol symbol-50px overflow-hidden" }
const _hoisted_53 = { class: "symbol-label" }
const _hoisted_54 = { class: "svg-icon svg-icon-1" }
const _hoisted_55 = { class: "flex-fill mx-2" }
const _hoisted_56 = { class: "fw-bold fs-5" }
const _hoisted_57 = {
  key: 0,
  class: "fs-6 text-gray-400"
}
const _hoisted_58 = {
  key: 1,
  class: "fs-6 text-gray-400"
}
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_61 = ["value"]
const _hoisted_62 = {
  key: 4,
  class: "col-md-12 mb-7"
}
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_65 = {
  key: 0,
  class: "text-gray-400 mt-3"
}
const _hoisted_66 = { class: "col-md-6 mb-7" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_69 = { class: "col-md-6 mb-7" }
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_72 = { class: "col-md-6 mb-7" }
const _hoisted_73 = { class: "form-group" }
const _hoisted_74 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_75 = { class: "col-md-6 mb-7" }
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_78 = { class: "col-md-6 mb-7" }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_81 = { class: "col-md-6 mb-7" }
const _hoisted_82 = { class: "form-group" }
const _hoisted_83 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_84 = { class: "col-md-6 mb-7" }
const _hoisted_85 = { class: "form-group" }
const _hoisted_86 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_87 = { class: "col-md-6 mb-7" }
const _hoisted_88 = { class: "form-group" }
const _hoisted_89 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_90 = { class: "col-md-6 mb-7" }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_93 = {
  key: 7,
  class: "col-md-6 mb-7"
}
const _hoisted_94 = { class: "form-group" }
const _hoisted_95 = { class: "fs-6 fw-bold" }
const _hoisted_96 = { class: "el-form-item__content" }
const _hoisted_97 = { class: "modal-footer flex-wrap flex-column gap-3" }
const _hoisted_98 = { class: "svg-icon svg-icon-2" }
const _hoisted_99 = { class: "indicator-label" }
const _hoisted_100 = { class: "indicator-progress" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_102 = { class: "svg-icon svg-icon-2" }
const _hoisted_103 = { class: "indicator-label" }
const _hoisted_104 = { class: "indicator-progress" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_106 = { class: "modal-footer align-items-center justify-content-end" }
const _hoisted_107 = { class: "svg-icon svg-icon-2" }
const _hoisted_108 = { class: "indicator-label" }
const _hoisted_109 = { class: "indicator-progress" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_111 = { class: "svg-icon svg-icon-2" }
const _hoisted_112 = { class: "indicator-label" }
const _hoisted_113 = { class: "indicator-progress" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_common_profit_rate_option = _resolveComponent("common-profit-rate-option")!
  const _component_common_profit_rate_channel_option = _resolveComponent("common-profit-rate-channel-option")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t("orderAssign.quickRouting")), 1),
            _hoisted_6,
            _createElementVNode("span", null, "#" + _toDisplayString(_ctx.tableItemData.order_number), 1),
            _hoisted_7,
            _createElementVNode("span", null, "#SUB" + _toDisplayString(_ctx.tableItemData.position), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.tableItemData.__show.definite_inventory)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("salesOrderOverview.definitedInventory")), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.tableItemData.__show.definite_inventory), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tableItemData.purchase_required)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("orderAssign.purchaseRequirement")), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.tableItemData.purchase_required), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tableItemData.pim_notice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/finance/fin008.svg" })
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.t("salesOrder.additionalPimNotice")), 1),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.tableItemData.pim_notice), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tableItemData.distributor_order)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("orderAssign.referenceSalesOrderNumber")), 1),
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.tableItemData.distributor_order), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t("fulfillmentOrder.fulfillmentSource")), 1),
                        _createElementVNode("div", _hoisted_35, [
                          (_ctx.tableItemData.__show.distribution_model)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                _createElementVNode("span", _hoisted_37, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen045.svg" })
                                ]),
                                (_ctx.tableItemData.__show.distribution_model)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.tableItemData.__show.distribution_model), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode(_component_el_form_item, { prop: "fulfillment_type" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("label", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("span", _hoisted_43, [
                                    _createElementVNode("span", _hoisted_44, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm004.svg" })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.t(
                                    "fulfillmentOrder.fulfillmentSourceMerchant"
                                  )), 1)
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("span", _hoisted_48, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "radio",
                                      name: "fulfillment_type",
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.fulfillment_type) = $event)),
                                      value: _ctx.FulfillmentSource.Merchant
                                    }, null, 8, _hoisted_49), [
                                      [_vModelRadio, _ctx.formData.fulfillment_type]
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            (_ctx.options.warehouse.length > 0)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("span", _hoisted_53, [
                                        _createElementVNode("span", _hoisted_54, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm009.svg" })
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.t(
                                    "fulfillmentOrder.fulfillmentSourcePreStock"
                                  )), 1),
                                      (_ctx.getInventoryQty.arr.length === 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.t("orderAssign.preStock", [
                                    _ctx.getInventoryQty.qty,
                                    _ctx.getInventoryQty.arr[0],
                                  ])), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.t("orderAssign.preStockWarehouses", [
                                    _ctx.getInventoryQty.qty,
                                    _ctx.getInventoryQty.arr.length,
                                  ])), 1))
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                      _createElementVNode("span", _hoisted_60, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input",
                                          type: "radio",
                                          name: "fulfillment_type",
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.fulfillment_type) = $event)),
                                          value: _ctx.FulfillmentSource.PreStock
                                        }, null, 8, _hoisted_61), [
                                          [_vModelRadio, _ctx.formData.fulfillment_type]
                                        ])
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (
                    _ctx.tableItemData.relation_sku.range_size ||
                    _ctx.tableItemData.relation_sku.size == 'default'
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.t("order.size")), 1),
                          _createVNode(_component_el_form_item, { prop: "size" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_autocomplete, {
                                class: "w-100",
                                clearable: "",
                                modelValue: _ctx.formData.size,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.size) = $event)),
                                modelModifiers: { trim: true },
                                "fetch-suggestions": _ctx.querySearchAsync,
                                placeholder: _ctx.$t('common.plsEnter')
                              }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
                            ]),
                            _: 1
                          }),
                          (_ctx.tableItemData.relation_sku.range_size)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.t("order.rangeSize")) + ": " + _toDisplayString(_ctx.tableItemData.relation_sku.range_size), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                    _ctx.formData.fulfillment_type === _ctx.FulfillmentSource.Merchant
                  )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.t("order.merchant")), 1),
                            _createVNode(_component_el_form_item, { prop: "merchant" }, {
                              default: _withCtx(() => [
                                (_ctx.isMerchantSourceDefaultData)
                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                      key: 0,
                                      ref: "selectMerchant",
                                      onFocus: _ctx.cancelReadonly,
                                      "onHook:mounted": _ctx.cancelReadonly,
                                      onVisibleChange: _ctx.cancelReadonly,
                                      teleported: false,
                                      modelValue: _ctx.formData.merchant,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                                      filterable: "",
                                      clearable: "",
                                      "remote-show-suffix": "",
                                      remote: "",
                                      "remote-method": _ctx.searchMerchantSourceItems,
                                      loading: _ctx.options.merchantLoading,
                                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getSalesChannelsData($event, true))),
                                      placeholder: _ctx.t('common.plsSelect')
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder"]))
                                  : (_openBlock(), _createBlock(_component_el_select, {
                                      key: 1,
                                      class: "w-100",
                                      modelValue: _ctx.formData.merchant,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                                      filterable: "",
                                      clearable: "",
                                      loading: _ctx.options.merchantLoading,
                                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getSalesChannelsData($event, true))),
                                      placeholder: _ctx.t('common.plsSelect')
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.merchant_id,
                                            label: item.merchant_name,
                                            value: item.merchant_id
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_common_profit_rate_option, {
                                                "profit-rate-option": item,
                                                discountValue: 
                                _ctx.tableItemData.min_discount_value_requirement
                              
                                              }, null, 8, ["profit-rate-option", "discountValue"])
                                            ]),
                                            _: 2
                                          }, 1032, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "loading", "placeholder"]))
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.t("order.channel")), 1),
                            _createVNode(_component_el_form_item, { prop: "channel" }, {
                              default: _withCtx(() => [
                                (_ctx.isMerchantSourceDefaultData)
                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                      key: 0,
                                      class: "w-100",
                                      modelValue: _ctx.formData.channel,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.channel) = $event)),
                                      filterable: "",
                                      clearable: "",
                                      loading: _ctx.options.channelLoading,
                                      placeholder: _ctx.t('common.plsSelect')
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "loading", "placeholder"]))
                                  : (_openBlock(), _createBlock(_component_el_select, {
                                      key: 1,
                                      class: "w-100",
                                      modelValue: _ctx.formData.channel,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.channel) = $event)),
                                      clearable: "",
                                      loading: _ctx.options.channelLoading,
                                      onChange: _ctx.getSalesChannelsChange,
                                      placeholder: _ctx.t('common.plsSelect')
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.channel_id,
                                            label: item.channel_name,
                                            value: item.channel_id
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_common_profit_rate_channel_option, {
                                                "profit-rate-channel-option": item,
                                                discountValue: 
                                _ctx.tableItemData.min_discount_value_requirement
                              
                                              }, null, 8, ["profit-rate-channel-option", "discountValue"])
                                            ]),
                                            _: 2
                                          }, 1032, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "loading", "onChange", "placeholder"]))
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (
                    _ctx.formData.fulfillment_type === _ctx.FulfillmentSource.PreStock
                  )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.t("warehouse.warehouse")), 1),
                            _createVNode(_component_el_form_item, { prop: "warehouse_key" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.warehouse_key,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.warehouse_key) = $event)),
                                  clearable: "",
                                  filterable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  onChange: _ctx.getFulfillmentOrderItemsSpotInventory
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouse, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.key,
                                        label: item.name,
                                        value: item.key
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.t("inventory.inventoryType")), 1),
                            _createVNode(_component_el_form_item, { prop: "inventory_type" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.inventory_type,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.inventory_type) = $event)),
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  onChange: _ctx.getFulfillmentOrderItemsSpotInventory
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.inventory_type, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.t("fulfillmentOrder.merchant")), 1),
                            _createVNode(_component_el_form_item, { prop: "merchant_key" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.merchant_key,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.merchant_key) = $event)),
                                  clearable: "",
                                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getSalesChannelsData($event, false))),
                                  placeholder: _ctx.t('common.plsSelect')
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchantDefault, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.name + ' (' + item.qty + ')',
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ], 512), [
                          [_vShow, 
                      _ctx.formData.warehouse_key !== '' &&
                      _ctx.formData.inventory_type != ''
                    ]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.t("fulfillmentOrder.channel")), 1),
                            _createVNode(_component_el_form_item, { prop: "channel_key" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.channel_key,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.channel_key) = $event)),
                                  clearable: "",
                                  loading: _ctx.options.channelLoading,
                                  placeholder: _ctx.t('common.plsSelect')
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channelDefault, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.name + ' (' + item.qty + ')',
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "loading", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ], 512), [
                          [_vShow, 
                      _ctx.formData.warehouse_key !== '' &&
                      _ctx.formData.inventory_type != '' &&
                      _ctx.formData.merchant_key != ''
                    ]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.t("order.merchantOrderNumber")), 1)
                          ]),
                          _createVNode(_component_el_form_item, { prop: "merchant_order" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.merchant_order,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.merchant_order) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchantOrders, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name + ' (' + item.qty + ')',
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, 
                      _ctx.formData.merchant_key !== '' && _ctx.formData.channel_key != ''
                    ]
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.t("salesOrder.externalOrderNumber")), 1),
                      _createVNode(_component_el_form_item, { prop: "external_order_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.external_order_number,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.external_order_number) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.t("order.purchaseQuantity")), 1),
                      _createVNode(_component_el_form_item, { prop: "quantity" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            class: "w-100",
                            modelValue: _ctx.formData.quantity,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.quantity) = $event)),
                            precision: 0,
                            step: 1,
                            min: 1,
                            max: _ctx.tableItemData.open_qty
                          }, null, 8, ["modelValue", "max"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (
                    _ctx.formData.fulfillment_type === _ctx.FulfillmentSource.Merchant &&
                    _ctx.options.profit_rate &&
                    _ctx.formData.merchant &&
                    _ctx.formData.channel
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.t("orderAssign.estimatedGrossProfit")), 1),
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                          'text-primary': Number(_ctx.options.profit_rate) >= 0,
                          'text-danger': Number(_ctx.options.profit_rate) < 0,
                        })
                            }, _toDisplayString(Number(_ctx.options.profit_rate).toFixed(2)) + "% ", 3)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              ])
            ]),
            _createVNode(_component_window_resize, null, {
              sm: _withCtx(() => [
                _createElementVNode("div", _hoisted_97, [
                  _withDirectives(_createElementVNode("button", {
                    ref: _ctx.submitButton,
                    type: "submit",
                    class: "btn btn-light btn-active-warning w-100"
                  }, [
                    _createElementVNode("span", _hoisted_98, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil004.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.t("orderAssign.createDraft")), 1),
                    _createElementVNode("span", _hoisted_100, [
                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                      _hoisted_101
                    ])
                  ], 512), [
                    [_vShow, 
                    _ctx.tableItemData.definite_inventory_source !==
                      String(_ctx.DefiniteInventorySource.Agent) ||
                    (_ctx.tableItemData.definite_inventory_source ===
                      String(_ctx.DefiniteInventorySource.Agent) &&
                      _ctx.formData.fulfillment_type ===
                        _ctx.FulfillmentSource.PreStock) ||
                    String(_ctx.tableItemData.store_id) === '21'
                  ]
                  ]),
                  _withDirectives(_createElementVNode("button", {
                    ref: _ctx.submitButton,
                    type: "button",
                    class: "btn btn-primary w-100",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.sendRequest && _ctx.sendRequest(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_102, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil009.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.t("orderAssign.sendRequest")), 1),
                    _createElementVNode("span", _hoisted_104, [
                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                      _hoisted_105
                    ])
                  ], 512), [
                    [_vShow, 
                    _ctx.formData.fulfillment_type === _ctx.FulfillmentSource.Merchant
                  ]
                  ])
                ])
              ]),
              lg: _withCtx(() => [
                _createElementVNode("div", _hoisted_106, [
                  _withDirectives(_createElementVNode("button", {
                    ref: _ctx.submitButton,
                    type: "submit",
                    class: "btn btn-light btn-active-warning"
                  }, [
                    _createElementVNode("span", _hoisted_107, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil004.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.t("orderAssign.createDraft")), 1),
                    _createElementVNode("span", _hoisted_109, [
                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                      _hoisted_110
                    ])
                  ], 512), [
                    [_vShow, 
                    _ctx.tableItemData.definite_inventory_source !==
                      String(_ctx.DefiniteInventorySource.Agent) ||
                    (_ctx.tableItemData.definite_inventory_source ===
                      String(_ctx.DefiniteInventorySource.Agent) &&
                      _ctx.formData.fulfillment_type ===
                        _ctx.FulfillmentSource.PreStock) ||
                    String(_ctx.tableItemData.store_id) === '21'
                  ]
                  ]),
                  _withDirectives(_createElementVNode("button", {
                    ref: _ctx.submitButton,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.sendRequest && _ctx.sendRequest(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_111, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil009.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.t("orderAssign.sendRequest")), 1),
                    _createElementVNode("span", _hoisted_113, [
                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                      _hoisted_114
                    ])
                  ], 512), [
                    [_vShow, 
                    _ctx.formData.fulfillment_type === _ctx.FulfillmentSource.Merchant
                  ]
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}